import { render, staticRenderFns } from "./AppCadastroRelacionamento.vue?vue&type=template&id=47a2da41&"
import script from "./AppCadastroRelacionamento.vue?vue&type=script&lang=js&"
export * from "./AppCadastroRelacionamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports